<h2 mat-dialog-title>Decline commercial</h2>
<mat-dialog-content>
  <p class="muted">
    Please provide an explanation for the decline. The station will use this to create a new version.
  </p>
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="full-width"
    subscriptSizing="dynamic">
    <mat-label>Missing information (optional)</mat-label>
    <textarea
      matInput
      [(ngModel)]="missingInformation"
      name="missing"
      rows="2"
      placeholder="e.g. legal name, offer dates, script changes…"></textarea>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="full-width required"
    subscriptSizing="dynamic">
    <mat-label>Explanation for decline</mat-label>
    <textarea
      matInput
      [(ngModel)]="explanation"
      name="explanation"
      rows="3"
      placeholder="What should change so the station can revise the spot?"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="warn"
    type="button"
    class="submit-feedback-btn"
    (click)="submit()"
    [disabled]="!explanation.trim() || sending">
    <span class="submit-feedback-btn__content">
      @if (sending) {
        <mat-spinner diameter="20" class="submit-feedback-spinner" />
        <span>Sending…</span>
      } @else {
        <span>Submit feedback</span>
      }
    </span>
  </button>
</mat-dialog-actions>
